/**
 * Constants for metering point related values
 * Used across multiple components and utilities
 */

/**
 * Metering point direction constants
 */
export const METERING_POINT_DIRECTION = {
  CONSUMPTION: 'CONSUMPTION',
  GENERATION: 'GENERATION'
} as const;

/**
 * Connection type constants for generation metering points
 */
export const CONNECTION_TYPE = {
  SURPLUS_FEEDER: 'Überschusseinspeiser (Eigenversorger)',
  FULL_FEEDER: 'Volleinspeiser'
} as const;

/**
 * Type for metering point direction values
 */
export type MeteringPointDirection = typeof METERING_POINT_DIRECTION[keyof typeof METERING_POINT_DIRECTION];

/**
 * Type for connection type values
 */
export type ConnectionType = typeof CONNECTION_TYPE[keyof typeof CONNECTION_TYPE];
